import React from 'react';
import { PLANNING_MAP_MODE } from '../../utils/planningTier';

/**
 * Icon-only toggle between the legacy map coloring and the planning-deadline
 * tier mode. When active (pressed) the map shows planning tiers; when inactive
 * it falls back to the legacy coloring. Defaults to active.
 *
 * Bubble-phase stopPropagation lets the button receive the click first, then
 * keeps the event from panning the map underneath.
 */
export const PlanningModeToggle = ({ mode, onChange = () => {} }) => {
  const isPlanning = mode === PLANNING_MAP_MODE.PLANNING;

  const stop = (e) => {
    e.stopPropagation();
  };

  const toggle = () => {
    onChange(isPlanning ? PLANNING_MAP_MODE.LEGACY : PLANNING_MAP_MODE.PLANNING);
  };

  return (
    <div
      className="map__planning-toggle"
      data-testid="planning-mode-toggle"
      onPointerDown={stop}
      onMouseDown={stop}
      onClick={stop}
    >
      <button
        type="button"
        className={`map__planning-toggle-btn ${isPlanning ? 'is-active' : ''}`}
        data-testid="planning-mode-planning"
        aria-pressed={isPlanning}
        title={isPlanning ? 'Terminowość: włączona (kliknij, aby wrócić do widoku standardowego)' : 'Terminowość: wyłączona (kliknij, aby włączyć tiery terminowości)'}
        onClick={toggle}
      >
        <i className="bx bx-time-five" />
      </button>
    </div>
  );
};
